import * as React from 'react';
import { PageNumber } from './PageNumber';
import { SimpleResizeSensor } from '../common/SimpleResizeSensor';
import { pageSliderContainerHeight, pageSliderBackgroundColor } from '../../style/values';

declare global {
  interface Window {
    mdc: any;
  }
}

interface PageSliderProps {
  currentPage: number;
  numPages: number;
  onChange: (targetPage: number) => void;
}

export const pageSliderContainerStyle: React.CSSProperties = {
  flex: `0 1 ${pageSliderContainerHeight}px`,
  display: 'flex',
  backgroundColor: pageSliderBackgroundColor,
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
};

export class PageSlider extends React.Component<PageSliderProps, {}> {
  private rtl: boolean;
  private slider: any;
  private sliderElement: HTMLElement | null;

  public constructor(props: PageSliderProps) {
    super(props);
    this.rtl = false;
    this.slider = null;
    this.sliderElement = null;
  }

  public componentDidMount() {
    if (this.sliderElement == null) {
      return;
    }

    const MDCSlider = (window.mdc.slider.MDCSlider as any);
    this.slider = new MDCSlider(this.sliderElement);
    this.slider.value = this.props.currentPage + 1;
    this.slider.listen('MDCSlider:input', this.handleOnChange);
  }

  public componentWillReceiveProps(nextProps: PageSliderProps): void {
    if (this.slider != null) {
      this.slider.max = nextProps.numPages;
      this.slider.value = nextProps.currentPage + 1;
    }
  }

  public componentWillUnmount() {
    if (this.slider != null) {
      this.slider.destroy();
    }
  }

  private handleOnChange = (_ev: Event): void => {
    if (this.slider == null) {
      return;
    }

    const numPages: number = this.props.numPages;
    const value = this.slider.value;
    this.props.onChange(this.rtl ? numPages - value : value - 1);
  }

  private onResize = () => {
    // Quick Fix for WKWebView
    const updateLayout = () => {
      if (this.slider != null) {
        this.slider.layout();
      }
    };
    setTimeout(updateLayout, 300);
  }

  public render() {
    const numPages: number = this.props.numPages;
    const sliderStyle: React.CSSProperties = {
      width: '80%',
      marginTop: '-0.375em',
    };
    const pageNumberWrapperStyle: React.CSSProperties = {
      position: 'absolute',
      fontSize: '0.75em',
      left: 0,
      right: 0,
      bottom: '4px',
      textAlign: 'center',
    };

    return (
      <div style={pageSliderContainerStyle}>
        <div
          id="page-slider"
          className="mdc-slider mdc-slider--discrete"
          tabIndex={-1}
          style={sliderStyle}
          aria-valuemin={1}
          aria-valuemax={numPages}
          ref={el => this.sliderElement = el}>
          <SimpleResizeSensor onResize={this.onResize} />
          <div className="mdc-slider__track-container">
            <div className="mdc-slider__track"></div>
          </div>
          <div className="mdc-slider__thumb-container">
            <div className="mdc-slider__pin">
              <span className="mdc-slider__pin-value-marker"></span>
            </div>
            <svg className="mdc-slider__thumb" width="21" height="21">
              <circle cx="10.5" cy="10.5" r="7.875"></circle>
            </svg>
            <div className="mdc-slider__focus-ring"></div>
          </div>
        </div>
        <div style={pageNumberWrapperStyle}>
          <PageNumber currentPage={this.props.currentPage} numPages={this.props.numPages} />
        </div>
      </div>
    );
  }
}
